"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
/**
 * *******************************
 * Functions
 * *******************************
 */
/**
 * Return value for object, or object.property, else returns default value
 *
 * @export
 * @param {TResult} action
 * @returns {TResult}
 */
function safe(action, defaultResult) {
    try {
        var result = action();
        return !_1.isUndefined(result) ? result : defaultResult;
    }
    catch (e) {
        if (e.name === "TypeError" || e.name === "ReferenceError") {
            return defaultResult;
        }
        throw e;
    }
}
exports.safe = safe;
/**
 * Will return a boolean indicating wether the left value equals the right value.
 *
 * @export
 * @param {any} left
 * @param {any} right
 * @returns {boolean}
 */
function isEqual(left, right) {
    if (left === right) {
        return true;
    }
    if (Array.isArray(left) && Array.isArray(right)) {
        return _1.isEqualArrays(left, right);
    }
    if (_1.isObject(left) && _1.isObject(right)) {
        return _1.isEqualObjects(left, right);
    }
    return false;
}
exports.isEqual = isEqual;
/**
 * Will generate GUID (Globally Unique Identifier) string
 *
 * @export
 * @returns {string}
 */
function generateGuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
exports.generateGuid = generateGuid;
//# sourceMappingURL=function.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/function.js
// module id = 1187
// module chunks = 1